export default class Tooltip extends HTMLElement {
  constructor() {
    super();
    this.tooltipOpen = this.querySelector("[data-tooltip-open]");
    this.tooltipText = this.querySelector("[data-tooltip-text]");

    this.handleToggle = this.handleToggle.bind(this);
  }

  connectedCallback() {
    const isMobile = window.matchMedia(
      "(hover: none) and (pointer: coarse)",
    ).matches;

    if (isMobile && this.tooltipOpen) {
      this.tooltipOpen.addEventListener("click", this.handleToggle);
    }
  }

  handleToggle(e) {
    e.stopPropagation();

    // Close all other tooltips first
    document.querySelectorAll("tool-tip").forEach((tooltip) => {
      if (tooltip !== this) {
        tooltip.close();
      }
    });

    // Toggle this one
    this.tooltipText?.classList.toggle("tooltip-active");
  }

  close() {
    this.tooltipText?.classList.remove("tooltip-active");
  }
}

customElements.define("tool-tip", Tooltip);

// ONE global listener (outside the class)
document.addEventListener("click", () => {
  document.querySelectorAll("tool-tip").forEach((tooltip) => {
    tooltip.close();
  });
});
